import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import React from 'react';

import { App } from './App';
import { installSmartAppBanner } from './lib/smartAppBanner';
import './styles/globals.css';
import './styles/initial-loader.css';

installSmartAppBanner();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
